export type TIME_TRACKING_HAS_ERRORED = typeof TIME_TRACKING_HAS_ERRORED
export const TIME_TRACKING_HAS_ERRORED = '[Timetracking] TIME_TRACKING_HAS_ERRORED'

export type SET_ACTIVE_TIMETRACKING_TAB = typeof SET_ACTIVE_TIMETRACKING_TAB
export const SET_ACTIVE_TIMETRACKING_TAB = '[Timetracking] SET_ACTIVE_TIMETRACKING_TAB'

export type GET_TIME_TRACKING_ENTRIES = typeof GET_TIME_TRACKING_ENTRIES
export const GET_TIME_TRACKING_ENTRIES = '[Timetracking] GET_TIME_TRACKING_ENTRIES'

export type GET_TIME_TRACKING_ENTRIES_SUCCESS = typeof GET_TIME_TRACKING_ENTRIES_SUCCESS
export const GET_TIME_TRACKING_ENTRIES_SUCCESS = '[Timetracking] GET_TIME_TRACKING_ENTRIES_SUCCESS'

export type CREATE_TIME_TRACKING_ENTRY = typeof CREATE_TIME_TRACKING_ENTRY
export const CREATE_TIME_TRACKING_ENTRY = '[Timetracking] CREATE_TIME_TRACKING_ENTRY'

export type CREATE_TIME_TRACKING_ENTRY_SUCCESS = typeof CREATE_TIME_TRACKING_ENTRY_SUCCESS
export const CREATE_TIME_TRACKING_ENTRY_SUCCESS = '[Timetracking] CREATE_TIME_TRACKING_ENTRY_SUCCESS'

export type UPDATE_TIME_TRACKING_ENTRY = typeof UPDATE_TIME_TRACKING_ENTRY
export const UPDATE_TIME_TRACKING_ENTRY = '[Timetracking] UPDATE_TIME_TRACKING_ENTRY'

export type UPDATE_TIME_TRACKING_ENTRY_SUCCESS = typeof UPDATE_TIME_TRACKING_ENTRY_SUCCESS
export const UPDATE_TIME_TRACKING_ENTRY_SUCCESS = '[Timetracking] UPDATE_TIME_TRACKING_ENTRY_SUCCESS'

export type DELETE_TIME_TRACKING_ENTRY = typeof DELETE_TIME_TRACKING_ENTRY
export const DELETE_TIME_TRACKING_ENTRY = '[Timetracking] DELETE_TIME_TRACKING_ENTRY'

export type DELETE_TIME_TRACKING_ENTRY_SUCCESS = typeof DELETE_TIME_TRACKING_ENTRY_SUCCESS
export const DELETE_TIME_TRACKING_ENTRY_SUCCESS = '[Timetracking] DELETE_TIME_TRACKING_ENTRY_SUCCESS'

export type SELECTED_PROJECT_MODAL = typeof SELECTED_PROJECT_MODAL
export const SELECTED_PROJECT_MODAL = '[Timetracking] SELECTED_PROJECT_MODAL'

export type SELECTED_ACTIVITY_MODAL = typeof SELECTED_ACTIVITY_MODAL
export const SELECTED_ACTIVITY_MODAL = '[Timetracking] SELECTED_ACTIVITY_MODAL'

export type GET_TIME_TRACKING_INVOLVED_TASKS = typeof GET_TIME_TRACKING_INVOLVED_TASKS
export const GET_TIME_TRACKING_INVOLVED_TASKS = '[Timetracking] GET_TIME_TRACKING_INVOLVED_TASKS'

export type GET_TIME_TRACKING_INVOLVED_TASKS_SUCCESS = typeof GET_TIME_TRACKING_INVOLVED_TASKS_SUCCESS
export const GET_TIME_TRACKING_INVOLVED_TASKS_SUCCESS = '[Timetracking] GET_TIME_TRACKING_INVOLVED_TASKS_SUCCESS'

export type GET_TIME_TRACKING_INVOLVED_TASKS_HAS_ERRORED = typeof GET_TIME_TRACKING_INVOLVED_TASKS_HAS_ERRORED
export const GET_TIME_TRACKING_INVOLVED_TASKS_HAS_ERRORED = '[Timetracking] GET_TIME_TRACKING_INVOLVED_TASKS_HAS_ERRORED'

export type FILTER_TIME_TRACKING_INVOLVED_TASKS = typeof FILTER_TIME_TRACKING_INVOLVED_TASKS
export const FILTER_TIME_TRACKING_INVOLVED_TASKS = '[Timetracking] FILTER_TIME_TRACKING_INVOLVED_TASKS'

export type GET_TIME_TRACKING_CHART_DATA = typeof GET_TIME_TRACKING_CHART_DATA
export const GET_TIME_TRACKING_CHART_DATA = '[Timetracking] GET_TIME_TRACKING_CHART_DATA'

export type GET_TIME_TRACKING_CHART_DATA_SUCCESS = typeof GET_TIME_TRACKING_CHART_DATA_SUCCESS
export const GET_TIME_TRACKING_CHART_DATA_SUCCESS = '[Timetracking] GET_TIME_TRACKING_CHART_DATA_SUCCESS'

export type GET_TIME_TRACKING_CHART_DONUT_DATA = typeof GET_TIME_TRACKING_CHART_DONUT_DATA
export const GET_TIME_TRACKING_CHART_DONUT_DATA = '[Timetracking] GET_TIME_TRACKING_CHART_DONUT_DATA'

export type GET_TIME_TRACKING_CHART_DATA_DONUT_SUCCESS = typeof GET_TIME_TRACKING_CHART_DATA_DONUT_SUCCESS
export const GET_TIME_TRACKING_CHART_DATA_DONUT_SUCCESS = '[Timetracking] GET_TIME_TRACKING_CHART_DATA_DONUT_SUCCESS'

export const GET_CURRENT_TASKS = '[Timetracking] GET_CURRENT_TASKS'
export type GET_CURRENT_TASKS = typeof GET_CURRENT_TASKS

export const GET_CURRENT_TASKS_SUCCESS = '[Timetracking] GET_CURRENT_TASKS_SUCCESS'
export type GET_CURRENT_TASKS_SUCCESS = typeof GET_CURRENT_TASKS_SUCCESS

export type GET_PAGINATED_CURRENT_TASKS = typeof GET_PAGINATED_CURRENT_TASKS
export const GET_PAGINATED_CURRENT_TASKS = '[Timetracking] GET_PAGINATED_CURRENT_TASKS'

export const GET_PAGINATED_CURRENT_TASKS_SUCCESS = '[Timetracking] GET_PAGINATED_CURRENT_TASKS_SUCCESS'
export type GET_PAGINATED_CURRENT_TASKS_SUCCESS = typeof GET_PAGINATED_CURRENT_TASKS_SUCCESS

export const SET_CURRENT_TASKS_STATUS_FILTER = '[Timetracking] SET_CURRENT_TASKS_STATUS_FILTER'
export type SET_CURRENT_TASKS_STATUS_FILTER = typeof SET_CURRENT_TASKS_STATUS_FILTER

export const SET_PAGINATED_CURRENT_TASKS_ACTIVE_PAGE = '[Timetracking] SET_PAGINATED_CURRENT_TASKS_ACTIVE_PAGE'
export type SET_PAGINATED_CURRENT_TASKS_ACTIVE_PAGE = typeof SET_PAGINATED_CURRENT_TASKS_ACTIVE_PAGE

export const GET_CURRENT_DIRECT_COSTS = '[Timetracking] GET_CURRENT_DIRECT_COSTS'
export type GET_CURRENT_DIRECT_COSTS = typeof GET_CURRENT_DIRECT_COSTS

export const GET_CURRENT_DIRECT_COSTS_SUCCESS = '[Timetracking] GET_CURRENT_DIRECT_COSTS_SUCCESS'
export type GET_CURRENT_DIRECT_COSTS_SUCCESS = typeof GET_CURRENT_DIRECT_COSTS_SUCCESS

export type GET_PAGINATED_CURRENT_DIRECT_COSTS = typeof GET_PAGINATED_CURRENT_DIRECT_COSTS
export const GET_PAGINATED_CURRENT_DIRECT_COSTS = '[Timetracking] GET_PAGINATED_CURRENT_DIRECT_COSTS'

export const GET_PAGINATED_CURRENT_DIRECT_COSTS_SUCCESS = '[Timetracking] GET_PAGINATED_CURRENT_DIRECT_COSTS_SUCCESS'
export type GET_PAGINATED_CURRENT_DIRECT_COSTS_SUCCESS = typeof GET_PAGINATED_CURRENT_DIRECT_COSTS_SUCCESS

/* ADMIN */
export type GET_ADMIN_TIME_TRACKING_ENTRIES = typeof GET_ADMIN_TIME_TRACKING_ENTRIES
export const GET_ADMIN_TIME_TRACKING_ENTRIES = '[Timetracking] GET_ADMIN_TIME_TRACKING_ENTRIES'

export type GET_ADMIN_TIME_TRACKING_ENTRIES_SUCCESS = typeof GET_ADMIN_TIME_TRACKING_ENTRIES_SUCCESS
export const GET_ADMIN_TIME_TRACKING_ENTRIES_SUCCESS = '[Timetracking] GET_ADMIN_TIME_TRACKING_ENTRIES_SUCCESS'

export type CREATE_ADMIN_TIME_TRACKING_ENTRY = typeof CREATE_ADMIN_TIME_TRACKING_ENTRY
export const CREATE_ADMIN_TIME_TRACKING_ENTRY = '[Timetracking] CREATE_ADMIN_TIME_TRACKING_ENTRY'

export type CREATE_ADMIN_TIME_TRACKING_ENTRY_SUCCESS = typeof CREATE_ADMIN_TIME_TRACKING_ENTRY_SUCCESS
export const CREATE_ADMIN_TIME_TRACKING_ENTRY_SUCCESS = '[Timetracking] CREATE_ADMIN_TIME_TRACKING_ENTRY_SUCCESS'

export type UPDATE_ADMIN_TIME_TRACKING_ENTRY = typeof UPDATE_ADMIN_TIME_TRACKING_ENTRY
export const UPDATE_ADMIN_TIME_TRACKING_ENTRY = '[Timetracking] UPDATE_ADMIN_TIME_TRACKING_ENTRY'

export type UPDATE_ADMIN_TIME_TRACKING_ENTRY_SUCCESS = typeof UPDATE_ADMIN_TIME_TRACKING_ENTRY_SUCCESS
export const UPDATE_ADMIN_TIME_TRACKING_ENTRY_SUCCESS = '[Timetracking] UPDATE_ADMIN_TIME_TRACKING_ENTRY_SUCCESS'

export type SELECT_EMPLOYEE_FOR_TIME_TRACKING = typeof SELECT_EMPLOYEE_FOR_TIME_TRACKING
export const SELECT_EMPLOYEE_FOR_TIME_TRACKING = '[Timetracking] SELECT_EMPLOYEE_FOR_TIME_TRACKING'


/** Involved Tasks Report */

export const GET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS = '[Timetracking] GET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS'
export type GET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS = typeof GET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS

export const GET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS_SUCCESS = '[Timetracking] GET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS_SUCCESS'
export type GET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS_SUCCESS = typeof GET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS_SUCCESS

export const SORT_PROJECT_TIME_TRACKING_INVOLVED_TASKS_REPORT = '[Timetracking] SORT_PROJECT_TIME_TRACKING_INVOLVED_TASKS_REPORT'
export type SORT_PROJECT_TIME_TRACKING_INVOLVED_TASKS_REPORT = typeof SORT_PROJECT_TIME_TRACKING_INVOLVED_TASKS_REPORT

export const SET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS_ACTIVE_PAGE = '[Timetracking] SET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS_ACTIVE_PAGE'
export type SET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS_ACTIVE_PAGE = typeof SET_PAGINATED_TIME_TRACKING_INVOLVED_TASKS_ACTIVE_PAGE

export const SEARCH_PROJECT_TIME_TRACKING_INVOLVED_TASKS = '[Timetracking] SEARCH_PROJECT_TIME_TRACKING_INVOLVED_TASKS'
export type SEARCH_PROJECT_TIME_TRACKING_INVOLVED_TASKS = typeof SEARCH_PROJECT_TIME_TRACKING_INVOLVED_TASKS

/* END */
